import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../configure_store'

const _getState = (state: RootState) => state.relationMutations

export const getPendingRelationMutations = createSelector(
  _getState,
  (state) => (
    state.pendingRelationMutations
  )
)
